import secureLocalStorage from "react-secure-storage";
import api from "../../../../../src/api/index";


export function getEngagement(sd, ed) {
  return api.get(`raw_engagements/${secureLocalStorage.getItem("id")}?isSupervisor=${secureLocalStorage.getItem("is_supervisor")}&start=${sd}&end=${ed}`);
}

export function getTeam() {
  return api.get("myTeam");
}
